import { render, staticRenderFns } from "./RisksProportionChart.vue?vue&type=template&id=39927737&scoped=true"
import script from "./RisksProportionChart.vue?vue&type=script&lang=js"
export * from "./RisksProportionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39927737",
  null
  
)

export default component.exports